import { assertValidVersion } from "@tsparticles/engine";
import { RgbColorManager } from "./RgbColorManager.js";
export async function loadRgbColorPlugin(engine, refresh = true) {
    assertValidVersion(engine, "3.7.1");
    await engine.addColorManager(new RgbColorManager(), refresh);
}
